import { render, staticRenderFns } from "./yellowVService.vue?vue&type=template&id=176c55da&scoped=true&"
import script from "./yellowVService.vue?vue&type=script&lang=js&"
export * from "./yellowVService.vue?vue&type=script&lang=js&"
import style0 from "./yellowVService.vue?vue&type=style&index=0&id=176c55da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c55da",
  null
  
)

export default component.exports